'use client';
import React, { useState } from 'react';
import ProfileHero from './ProfileHero';
import ProfileStats from './ProfileStats';
import FavoriteDrinks from './FavoriteDrinks';
import OrderHistory from './OrderHistory';
import AccountSettings from './AccountSettings';

type Tab = 'favoriler' | 'siparisler' | 'ayarlar';

export default function ProfileClient() {
  const [activeTab, setActiveTab] = useState<Tab>('favoriler');

  const tabs: Array<{ id: Tab; label: string }> = [
    { id: 'favoriler', label: 'Favoriler' },
    { id: 'siparisler', label: 'Siparişler' },
    { id: 'ayarlar', label: 'Ayarlar' },
  ];

  return (
    <div>
      <ProfileHero />
      <ProfileStats />

      {/* Tabs */}
      <div className="px-4 py-3 bg-card border-b border-border sticky top-0 z-20">
        <div className="flex gap-1 bg-muted p-1 rounded-xl">
          {tabs.map((tab) => (
            <button
              key={`profile-tab-${tab.id}`}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-all duration-150 ${
                activeTab === tab.id
                  ? 'bg-white text-foreground card-shadow'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="px-4 py-4">
        {activeTab === 'favoriler' && <FavoriteDrinks />}
        {activeTab === 'siparisler' && <OrderHistory />}
        {activeTab === 'ayarlar' && <AccountSettings />}
      </div>
    </div>
  );
}